export function toFsEntryKey(extended) {
    return { id: extended.linkId, type: extended.type };
}
